import React from 'react'
import './PieCatalogo.css'
// Muestra un banner con la info de ofrecimiento sobre la compra de los productos 

const PieCatalogo = () => {
    return (
        
        <div className="container-fluid pie-catalo">
            <div className="row grids-envio-info ">
                <div className="col-lg-4 ab-content-1">
                    <div className="ab-info-con">
                        <h4>ENVÍO RÁPIDO Y GRATUITO</h4>
                        <p>Lorem ipsum dolor sit,Nulla pellentesque dolor ipsum laoreet eleifend integer,Pellentesque maximus libero.</p>
                    </div>
                </div>
                <div className="col-lg-4 ab-content-2">
                    <div className="ab-info-con">
                        <h4>PAGOS SEGUROS Y ONLINE</h4>
                        <p>Lorem ipsum dolor sit,Nulla pellentesque dolor ipsum laoreet eleifend integer,Pellentesque maximus libero.</p>
                    </div>
                </div>
                <div className="col-lg-4 ab-content-3">
                    <div className="ab-info-con">
                        <h4>GARANTÍA DE DEVOLUCIÓN DEL 100% </h4>
                        <p>Lorem ipsum dolor sit,Nulla pellentesque dolor ipsum laoreet eleifend integer,Pellentesque maximus libero.</p>
                    </div>
                </div>
            </div>
        </div>
       
    )
}
 export default PieCatalogo;